import React from "react";
import PropTypes from "prop-types";

class FlaggableHierarchyTreeItemReadOnly extends React.Component {
  get paddingLeft() {
    return `${this.props.indentSize * this.props.layer + 24}px`;
  }

  render() {
    return (
      <div
        className="tree-item my-1 w-100"
        style={{
          ...this.props.style,
          paddingLeft: this.paddingLeft,
        }}
      >
        <span
          className="pl-1 pt-1 pb-1"
          style={{
            ...this.props.style,
            display: "inline-block",
            fontWeight: this.props.isSelected ? 900 : 400,
            minHeight: `${this.props.indentSize}px`,
          }}
        >
          {this.props.isSelected ? <span>&#9679;</span> : <span>&#9675;</span>} {this.props.label}
        </span>
      </div>
    );
  }
}

FlaggableHierarchyTreeItemReadOnly.propTypes = {
  indentSize: PropTypes.number,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  layer: PropTypes.number,
  style: PropTypes.object,
};

FlaggableHierarchyTreeItemReadOnly.defaultProps = {
  indentSize: 16,
  layer: 0,
};

export default FlaggableHierarchyTreeItemReadOnly;
